import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ViewModal from "../../../components/Modal/ViewModal";
import Forms from "./Form";
const ViewForm = () => {
  const [postImages, setPostImages] = useState([]);
  const curdProps = useSelector((state) => state.CurdR);
  const { View_Sale_MODAL, initialValues } = curdProps;
  useEffect(() => {
    if (initialValues) {
      setPostImages(initialValues.postImages);
    }
  }, [initialValues]);
  return (
    <ViewModal
      modalTitle="View Sale Post"
      ModalName="View_Sale_MODAL"
      visible={View_Sale_MODAL}
      isShowButton={false}
      width={500}
    >
      <Forms postImages={postImages} />
    </ViewModal>
  );
};

export default ViewForm;
